import { BrandContextType } from '../common/types/BrandContextType';
import { NegotiationState } from '../../generated/graphql';

import theme from './theme';
import logo from './assets/logo';
import ConfirmByUserSVG from '../common/assets/illustrations/negotiationState/ConfirmByUserSVG';
import ExpiratedNegotiationSVG from '../common/assets/illustrations/negotiationState/ExpiratedNegotiationSVG';
import SentToBankSVG from '../common/assets/illustrations/negotiationState/SentToBankSVG';
import ApprovedByBankSVG from '../common/assets/illustrations/negotiationState/ApprovedByBankSVG';
import RejectedByBankSVG from '../common/assets/illustrations/negotiationState/RejectedByBankSVG';
import { getImageUrl } from '../../utils/imagesRoot';

export default {
  name: 'TRANQUI',
  homepageUrl: 'https://tranquifinanzas.com',
  theme,
  logo,
  illustrations: {
    loginMain: getImageUrl('branding/tranquifinanzas/LoginImg.png'),
    negotiationState: {
      [NegotiationState.ConfirmedByUser]: ConfirmByUserSVG,
      [NegotiationState.Expired]: ExpiratedNegotiationSVG,
      [NegotiationState.SentToBank]: SentToBankSVG,
      [NegotiationState.ApprovedByBank]: ApprovedByBankSVG,
      [NegotiationState.RejectedByBank]: RejectedByBankSVG,
      [NegotiationState.PrepaymentIncomplete]: ExpiratedNegotiationSVG,
      [NegotiationState.PrepaymentCompleted]: SentToBankSVG,
    },
  },
} as BrandContextType;
